"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const DownloadIso_1 = tslib_1.__importDefault(require("./DownloadIso"));
const use_translation_wrapper_1 = require("../../hooks/use-translation-wrapper");
const DownloadIsoModal = (_a) => {
    var { isOpen } = _a, props = tslib_1.__rest(_a, ["isOpen"]);
    const { t } = (0, use_translation_wrapper_1.useTranslation)();
    return (react_1.default.createElement(react_core_1.Modal, { "aria-label": t('ai:Download host discovery ISO dialog'), title: t('ai:Add host'), isOpen: isOpen, onClose: props.onClose, variant: react_core_1.ModalVariant.small, hasNoBodyWrapper: true, id: "download-discovery-iso-modal" },
        react_1.default.createElement(DownloadIso_1.default, Object.assign({}, props))));
};
exports.default = DownloadIsoModal;
//# sourceMappingURL=DownloadIsoModal.js.map